<script lang="ts">
  import { _ } from 'svelte-i18n';
  import {
    calculateResizeMargin,
    calculateResizePercentage
  } from '../../etc/resize';
  import { AppState } from '../../etc/stores';
  import BackgroundCoin from '../icons/BackgroundCoin.svelte';

  type TType = 'default' | 'percentage';

  export let value: string | number = '';
  export let type: TType = 'default';
  export let size: string = '75';

  const currencySymbol = $AppState.business.location.currencySymbol;
  const isPercentage = type === 'percentage';
  const componentSize = 75;

  const calculateSize = () => {
    return calculateResizePercentage(componentSize, size);
  };

  const calculateMargin = () => {
    return calculateResizeMargin(componentSize, size);
  };

  $: medium = String(value).length === 2;
  $: small = String(value).length >= 3;
  $: verysmall = String(value).length >= 4;
</script>

<div
  class="reward-coin"
  style="transform: scale({calculateSize()}); margin: {calculateMargin()}px {calculateMargin()}px"
  class:--medium={medium}
  class:--small={small}
  class:--very-small={verysmall}
  class:--percentage={isPercentage}
>
  <BackgroundCoin />
  <div class="reward-coin__wrapper">
    {#if !isPercentage}
      <span class="reward-coin__currency">
        {currencySymbol}
      </span>
    {/if}
    <span class="reward-coin__value">
      {value}
    </span>
    {#if isPercentage}
      <span class="reward-coin__percentage">%</span>
    {/if}
    <span class="reward-coin__off">OFF</span>
  </div>
</div>

<style lang="scss">
  .reward-coin {
    position: relative;
    height: 75px;
    width: fit-content;

    &.--medium {
      .reward-coin__value {
        font-size: 34px;
        line-height: 37px;
      }
      .reward-coin__off {
        font-size: 10px;
        line-height: 12px;
        bottom: 5px;
      }

      .reward-coin__percentage {
        font-size: 12px;
        top: 1px;
      }
    }

    &.--small {
      .reward-coin__currency {
        font-size: 10.5px;
      }
      .reward-coin__value {
        font-size: 24px;
        line-height: 35px;
      }
      .reward-coin__off {
        font-size: 9px;
        line-height: 11px;
        right: -4px;
        bottom: 8px;
      }

      .reward-coin__wrapper {
        transform: translate(calc(-50% - 2px), calc(-50% + 2px));
      }

      .reward-coin__percentage {
        font-size: 11px;
        top: 1px;
        right: -12px;
      }

      &.--percentage {
        .reward-coin__wrapper {
          transform: translate(calc(-50% - 5px), calc(-50% + 3px));
        }
        .reward-coin__off {
          right: -12px;
          bottom: 9px;
        }
        .reward-coin__value {
          font-size: 22px;
        }
      }
    }

    &.--very-small {
      .reward-coin__value {
        font-size: 17px;
      }
    }

    &__wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(calc(-50% - 5px), calc(-50% + 2px));
      display: flex;
      width: max-content;
    }

    &__currency {
      font-weight: 700;
      font-size: 11.5px;
      line-height: 14px;
      letter-spacing: 0.02em;
      transform: translateY(5px);
      color: #fff;
    }

    &__value {
      font-weight: 700;
      font-size: 40px;
      line-height: 40px;
      transform: translateY(-3px);
      text-align: left;
      letter-spacing: -0.042em;
      background: linear-gradient(
        135.38deg,
        #fff 13.42%,
        rgba(255, 255, 255, 0) 95.98%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      min-width: 18px;
      padding: 1px;
      clip-path: inset(1px);
    }

    &__off {
      position: absolute;
      right: -12px;
      bottom: 4px;
      font-weight: 700;
      font-size: 11px;
      line-height: 13px;
      letter-spacing: -0.02em;
      text-transform: uppercase;
      color: #fff;
    }

    &__percentage {
      position: absolute;
      top: -1px;
      right: -14px;
      font-weight: 700;
      font-size: 15px;
      line-height: 20px;
      letter-spacing: 0.02em;
      color: #fff;
    }
  }
</style>
